import { render, staticRenderFns } from "./Paygap.vue?vue&type=template&id=5d7d4d68"
import script from "./Paygap.vue?vue&type=script&lang=js"
export * from "./Paygap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports